const MAIN_SUBDOMAINS = new Set(["app", "app-dev", "www", "api", "api-dev", "admin"]);

export function getSubdomain(): string | null {
	const hostname = window.location.hostname;

	if (hostname === "localhost") return null;

	const parts = hostname.split(".");

	if (parts.length >= 2 && parts[parts.length - 1] === "localhost") {
		return parts[0] ?? null;
	}

	if (parts.length >= 3) {
		const sub = parts[0];
		if (!sub || MAIN_SUBDOMAINS.has(sub)) return null;

		if (sub.startsWith("dev-")) {
			return sub.slice(4);
		}

		return sub;
	}

	return null;
}

export function buildCommunityUrl(slug: string, path = "/"): string {
	const { protocol, port, hostname } = window.location;

	const isLocalhost = hostname === "localhost" || hostname.endsWith(".localhost");
	if (isLocalhost) {
		return `${protocol}//${slug}.localhost${port ? `:${port}` : ""}${path}`;
	}

	const parts = hostname.split(".");
	const baseDomain = parts.slice(-2).join(".");

	if (isStaging(parts)) {
		return `${protocol}//dev-${slug}.${baseDomain}${path}`;
	}

	return `${protocol}//${slug}.${baseDomain}${path}`;
}

export function getDomainSuffix(): string {
	const hostname = window.location.hostname;

	if (hostname === "localhost" || hostname.endsWith(".localhost")) {
		return ".localhost";
	}

	const parts = hostname.split(".");
	const baseDomain = parts.slice(-2).join(".");

	if (isStaging(parts)) {
		return `.${baseDomain}`;
	}

	return `.${baseDomain}`;
}

export function buildMainAppUrl(path = ""): string {
	const { protocol, port, hostname } = window.location;

	const isLocalhost = hostname === "localhost" || hostname.endsWith(".localhost");
	if (isLocalhost) {
		return `${protocol}//localhost${port ? `:${port}` : ""}${path}`;
	}

	const parts = hostname.split(".");
	const baseDomain = parts.slice(-2).join(".");

	if (isStaging(parts)) {
		return `${protocol}//app-dev.${baseDomain}${path}`;
	}

	return `${protocol}//app.${baseDomain}${path}`;
}

function isStaging(hostnameParts: string[]): boolean {
	const sub = hostnameParts[0];
	if (!sub) return false;
	return sub === "app-dev" || sub.startsWith("dev-");
}
